<script>
  import { onMount, createEventDispatcher } from "svelte";
  import Loading from "./Loading.svelte";
  import Conexoes from "../Classes/Conexoes";
  import Constantes from "../Classes/Constantes";

  import { Card, Paper } from "@svelteuidev/core";

  export let config;

  export let saida = [];
  const dispatch = createEventDispatcher();
  let api;
  let query_code;

  let campos_pesquisaveis;
  let primeiroDisparo = false;
  let colunas_exibidas;
  let coluna_saida;
  let termo_pesquisa;
  let conexao = new Conexoes();
  let dados = [];
  let showModal = false;
  let keys = [];
  let selectedRows = [];
  let selecionado = [];
  let page = 0;
  let size = 10;
  let carregando = false;
  let IgnorarId = true;
  let timer;
  let titulo = "Selecione os dados";
  function Pesquisar() {
    // Cancela o timer anterior se houver um
    carregando = true;
    clearTimeout(timer);

    // Configura um novo timer para despachar a pesquisa após 2 segundos
    timer = setTimeout(() => {
      dados = [];
      page = 0;
      pegaDados();
      carregando = false;
    }, 2000);
  }

  async function pegaDados() {
    carregando = true;
    let parametro_adicional = "";
    if (config.parametro_adicional) {
      parametro_adicional = config.parametro_adicional;
    }
    let resultado = await conexao.conecta(api, {
      query_code: query_code,
      posicao: page,
      tamanho: size,
      campos_pesquisaveis: campos_pesquisaveis,
      termo_pesquisa: termo_pesquisa,
      parametro_adicional: parametro_adicional,
    });
    dados = [...dados, ...resultado];
    if (dados.length > 0) {
      keys = Object.keys(dados[0]);
    }
    carregando = false;
  }
  function IniciarParametros() {
    api = config.api;
    query_code = config.query_code;

    campos_pesquisaveis = config.campos_pesquisaveis;

    colunas_exibidas = config.colunas_exibidas;
    coluna_saida = config.coluna_saida;
    titulo = config.titulo;
  }
  onMount(async () => {
    await config;
    IniciarParametros();

    pegaDados();
  });

  function closeModal() {
    showModal = false;
  }

  function toggleRowSelection(dado, idx) {
    const index = selectedRows.findIndex(
      (row) => JSON.stringify(row) === JSON.stringify(dado),
    );
    if (index === -1) {
      if (config.selecaoUnica) {
        selectedRows = [dado];
      } else {
        selectedRows = [...selectedRows, dado];
      }
    } else {
      selectedRows = selectedRows.filter(
        (row) => JSON.stringify(row) !== JSON.stringify(dado),
      );
    }

    saida = selectedRows.map((row) => row[coluna_saida]);
    console.log("saida", saida);
    isSelected(idx);
    dispatch("selecionado", dado);
    if (config.selecaoUnica) {
      closeModal();
    }
  }

  function isSelected(idx) {
    if (!selecionado[idx]) {
      selecionado[idx] = "table-secondary";
    } else {
      selecionado[idx] = "";
    }
  }

  function removeSelectedRow(idx) {
    selectedRows.splice(idx, 1);
    selectedRows = [...selectedRows];
    selecionado[idx] = ""; // Limpa a classe 'table-secondary'
  }

  function clearSelectedRows() {
    selectedRows = [];
    selecionado = [];
  }

  function handleScroll(event) {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop + clientHeight >= scrollHeight - 50 && !carregando) {
      if (page < size) {
        page = page + size;
        pegaDados();
      }
    }
  }
  function ColunasExibidas(row) {
    let saida = "";

    colunas_exibidas.forEach((elemento) => {
      saida += row[elemento] + " - ";
      console.log("Colunas", elemento);
      console.log("saidas", saida);
    });

    saida = rtrimChar(saida, " - ") + "...";
    return saida;
  }
  function rtrimChar(str, char) {
    if (str.endsWith(char)) {
      return str.slice(0, -1);
    }
    return str;
  }
</script>

<div class="container">
  <Paper>
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label for="data-input" class="form-label">{titulo}</label>
          <input
            id="data-input"
            type="text"
            class="form-control disabled-input"
            readonly
            placeholder="Selecione os dados"
            on:click={() => (showModal = true)}
          />
        </div>
      </div>
    </div>
    <div
      class="selected-rows-container"
      style="max-height: 300px; overflow-y: auto;"
    >
      {#each selectedRows as row, idx}
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control disabled-input"
            readonly
            value={ColunasExibidas(row)}
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            on:click={() => removeSelectedRow(idx)}
          >
            <i class="fa fa-trash"></i>
          </button>
        </div>
      {/each}
    </div>
  </Paper>
</div>

{#if showModal}
  <div
    class="modal d-block"
    tabindex="-1"
    aria-labelledby="dataModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="dataModalLabel">Selecione os dados</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            on:click={closeModal}
          ></button>
        </div>
        <div class="modal-body" on:scroll={handleScroll}>
          {#if dados.length === 0}
            <Loading {carregando} />
          {:else}
            <div class="d-flex align-items-center w-100 largura">
              <input
                class="flex-grow-1"
                type="text"
                placeholder="Pesquisar..."
                bind:value={termo_pesquisa}
                on:input={Pesquisar}
              />
              {#if !carregando}
                <i class="fas fa-search fa-lg search-icon"></i>
              {:else}
                <Loading {carregando} />
              {/if}
            </div>
            <table class="table">
              <thead>
                <tr>
                  {#each keys as key, j}
                    {#if !IgnorarId || (IgnorarId && key != "id")}
                      <th scope="col">{key}</th>
                    {/if}
                  {/each}
                </tr>
              </thead>
              <tbody>
                {#each dados as dado, idx}
                  <tr
                    class={selectedRows.some((row) => row.id === dado.id)
                      ? "table-secondary"
                      : ""}
                    on:click={() => toggleRowSelection(dado, idx)}
                    style="cursor: pointer;"
                  >
                    {#each keys as key}
                      {#if !IgnorarId || (IgnorarId && key != "id")}
                        <td>{@html dado[key]}</td>
                      {/if}
                    {/each}
                  </tr>
                {/each}
              </tbody>
            </table>
          {/if}
          {#if carregando}
            <Loading {carregando} />
          {/if}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" on:click={closeModal}
            >Cancelar</button
          >

          <button
            type="button"
            class="btn btn-danger"
            on:click={clearSelectedRows}
            >Limpar tudo
          </button>
          {#if !config.selecaoUnica}
            <button type="button" class="btn btn-primary" on:click={closeModal}
              >Confirmar</button
            >
          {/if}
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal.d-block {
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-dialog-scrollable {
    max-height: 80vh;
  }

  .table-secondary {
    background-color: grey !important;
    color: white;
  }

  .largura {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
  }

  input {
    margin-left: 2px;
  }

  .search-icon {
    padding-inline: 5px;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .disabled-input {
    background-color: #f0f0f0;
    cursor: not-allowed;
  }

  .loading {
    height: 50px; /* Altura do ícone de carregamento */
  }

  .fa-spinner {
    animation: spin 1s infinite linear; /* Animação de rotação */
    display: flex;
    justify-content: center;
    align-items: center;
    padding-inline: 5px;
  }
</style>
